import React from "react";

type ContextProps = {
  startAddress: null,
  startLat: null,
  startLon: null,
  destinationAddress: null,
  destinationLat: null,
  destinationLon: null,
}

const AppContext = React.createContext<Partial<ContextProps>>({});

export default AppContext;
